import React, { useState, useEffect } from "react";
import api from "./api";
import { FaSpinner, FaSearch, FaTimes } from "react-icons/fa";

function ScanInvoice() {
  const [sufUrl, setSufUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    document.getElementById("sufUrlInput")?.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    if (!sufUrl.trim()) {
      setMessage("Unesite validan URL.");
      return;
    }
    setLoading(true);
    try {
      const response = await api.post(
        "/api/scanInvoice",
        { sufUrl },
        { responseType: "blob" }
      );
      if (response.status === 200) {
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "scanned_invoice.dbf";
        if (contentDisposition) {
          const match = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          if (match && match[1]) {
            fileName = match[1].replace(/['"]/g, "");
          }
        }
        const blob = new Blob([response.data], {
          type: response.headers["content-type"] || "application/dbf",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
        setMessage("Fajl uspesno preuzet!");
      } else {
        setMessage("Preuzimanje neuspesno.");
      }
    } catch (error) {
      setMessage("Greska. Proverite URL.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-card">
      <h2 className="page-title">Skeniranje fakture</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>URL fakture</label>
          <input
            id="sufUrlInput"
            type="text"
            className="form-control"
            value={sufUrl}
            onChange={(e) => setSufUrl(e.target.value)}
            placeholder="Unesite URL za skeniranje"
          />
        </div>
        <div style={{ display: "flex", gap: 12 }}>
          <button type="submit" className="btn-primary" disabled={loading} style={{ flex: 1 }}>
            {loading ? (
              <>
                <FaSpinner className="spin" /> Preuzimanje...
              </>
            ) : (
              <>
                <FaSearch style={{ marginRight: 8 }} /> Skeniraj
              </>
            )}
          </button>
          <button
            type="button"
            className="btn-secondary"
            onClick={() => { setSufUrl(""); setMessage(""); }}
            style={{ flex: 0 }}
          >
            <FaTimes style={{ marginRight: 4 }} /> Obrisi
          </button>
        </div>
      </form>
      {message && (
        <div
          className={`status-message ${
            message.includes("uspesno") ? "success" : "error"
          }`}
        >
          {message}
        </div>
      )}
    </div>
  );
}

export default ScanInvoice;
